import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/TEAMSS-Logo 1.png")